import { render, staticRenderFns } from "./lcwClueManagement.vue?vue&type=template&id=4711031e"
import script from "./lcwClueManagement.vue?vue&type=script&lang=js"
export * from "./lcwClueManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports